/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import { func } from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';

import {
  withMeetingContext,
  MeetingContextAVControlsProps,
} from 'Scenes/_root/meetingContext';

class AudioIndicator extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      prog: 0,
    };
    this.deregisterMeetingCallbacks = props.registerMeetingCallbacks('audioIndicator', {
      onSelectedAudioInDeviceIdUpdated: this.createAudioStage,
    });
  }

  componentDidMount() {
    this._isMounted = true;
    this.createAudioStage();
  }

  componentWillUnmount() {
    const { avControls } = this.props;
    this._isMounted = false;
    avControls.audioIn.analyserNode.destroy();
    cancelAnimationFrame(this.analyserNodeCallback);
    this.deregisterMeetingCallbacks();
  }

  createAudioStage = async () => {
    const { avControls } = this.props;

    try {
      let analyserNode;
      await avControls.audioIn.analyserNode.create().then((node) => { analyserNode = node; });
      const analyserNodeData = new Uint8Array(analyserNode.fftSize);
      if (!analyserNode.getByteTimeDomainData) {
        window.console.log('[AudioIndicator]', 'Node not able to getFloatTimeDomainData');
        return;
      }

      // yanked from the Chime demo app and adapted
      let frameIndex = 0;
      this.analyserNodeCallback = () => {
        if (frameIndex === 0) {
          analyserNode.getByteTimeDomainData(analyserNodeData);
          const lowest = 0.01;
          let max = lowest;
          // eslint-disable-next-line no-restricted-syntax
          for (const f of analyserNodeData) {
            max = Math.max(max, (f - 128) / 128);
          }
          // eslint-disable-next-line prefer-const
          let normalized = (Math.log(lowest) - Math.log(max)) / Math.log(lowest);
          // eslint-disable-next-line prefer-const
          let percent = Math.round(Math.min(Math.max(normalized * 100, 0), 100));

          if (this._isMounted) {
            this.setState({ prog: percent });
          }
        }
        frameIndex = (frameIndex + 1) % 2;
        requestAnimationFrame(this.analyserNodeCallback);
      };
      requestAnimationFrame(this.analyserNodeCallback);
    } catch (error) {
      console.log(`${error}: An error occured in <AudioIndicator />`);
    }
  }

  render() {
    const { prog } = this.state;
    return (
      <LinearProgress value={prog} variant="determinate" />
    );
  }
}

AudioIndicator.propTypes = {
  avControls: MeetingContextAVControlsProps,
  registerMeetingCallbacks: func.isRequired,
};


export default withMeetingContext(['registerMeetingCallbacks', 'avControls'])(AudioIndicator);
